import { Injectable } from '@angular/core';
import { ConfirmationWindowComponent } from '@components/confirmation-window/confirmation-window.component';
import { Observable } from 'rxjs';

export interface ConfirmationPromptServiceInitParams {
    window: ConfirmationWindowComponent;
}

export interface ConfirmationPromptOptions {
    mainLabel: string;
    subLabel?: string;

    confirmLabel: string;
    cancelLabel: string;
}

@Injectable()
export class ConfirmationPromptService {
    private window: ConfirmationWindowComponent;

    public init(params: ConfirmationPromptServiceInitParams) {
        this.window = params.window;
    }

    public onOptionSelected(): Observable<boolean> {
        return new Observable<boolean>((subscriber) => {
            const sub = this.window.onOptionSelected.subscribe((confirm) => {
                subscriber.next(confirm);
                subscriber.complete();
            });

            return () => sub.unsubscribe();
        });
    }

    public showPrompt(options: ConfirmationPromptOptions) {
        this.window.mainLabel = options.mainLabel ?? '';
        this.window.subLabel = options.subLabel ?? '';
        this.window.confirmLabel = options.confirmLabel ?? '';
        this.window.cancelLabel = options.cancelLabel ?? '';

        this.window.setVisible(true);
    }
}
